import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CompassIcon } from './icons';
import { careerDirectionApi } from './api';

/**
 * The intern's career direction (3-month program job title). Labelled
 * "Career direction" on purpose — it is a role direction, not an official
 * or guaranteed job title.
 */
export default function CareerDirectionCard({ className = '' }) {
    const [data, setData] = useState(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let cancelled = false;
        careerDirectionApi.mine()
            .then((d) => !cancelled && setData(d))
            .catch(() => !cancelled && setFailed(true));
        return () => { cancelled = true; };
    }, []);

    if (failed) return null;
    if (!data) return <div className={`h-[92px] animate-pulse rounded-2xl bg-ink-100 ${className}`} />;

    return (
        <section aria-label="Career direction" className={`flex items-start gap-4 rounded-2xl border border-brand-200/70 bg-gradient-to-br from-brand-50/80 to-white p-5 ${className}`}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-700 text-white">
                <CompassIcon className="h-6 w-6" />
            </span>
            <div className="min-w-0">
                <p className="font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-brand-700">Career direction</p>
                {data.job_title ? (
                    <>
                        <p className="mt-0.5 text-xl font-bold tracking-tight text-ink-950">{data.job_title}</p>
                        <p className="mt-1 text-xs text-ink-600">
                            {data.degree_group ? <>Based on your degree: <span className="font-medium text-ink-800">{data.degree_group.name}</span> · </> : null}
                            {data.note}
                        </p>
                    </>
                ) : (
                    <p className="mt-1 text-sm text-ink-700">
                        Add your degree or program to your <Link to="/profile" className="font-semibold text-brand-700 underline underline-offset-2">Talent Profile</Link> and
                        your career direction will appear here.
                    </p>
                )}
            </div>
        </section>
    );
}
